import React, { useMemo } from "react";
import { motion } from "framer-motion";

const FloatingParticles = ({ count = 30, className = "" }) => {
    const particles = useMemo(() => {
        return Array.from({ length: count }, (_, i) => ({
            id: i,
            size: Math.random() * 4 + 2, // 2-6px
            x: Math.random() * 100, // 0-100%
            y: Math.random() * 100, // 0-100%
            duration: Math.random() * 20 + 20, // 20-40s
            delay: Math.random() * 5,
            opacity: Math.random() * 0.3 + 0.1, // 0.1-0.4
        }));
    }, [count]);

    return (
        <div className={`fixed inset-0 overflow-hidden pointer-events-none ${className}`}>
            {particles.map((particle) => (
                <motion.div
                    key={particle.id}
                    className="absolute rounded-full bg-gradient-to-br from-blue-400 via-purple-400 to-pink-400"
                    style={{
                        width: particle.size,
                        height: particle.size,
                        left: `${particle.x}%`,
                        top: `${particle.y}%`,
                        opacity: particle.opacity,
                    }}
                    animate={{
                        y: [0, -30, 0],
                        x: [0, Math.random() * 20 - 10, 0],
                        scale: [1, 1.2, 1],
                        opacity: [particle.opacity, particle.opacity * 1.5, particle.opacity],
                    }}
                    transition={{
                        duration: particle.duration,
                        repeat: Infinity,
                        delay: particle.delay,
                        ease: "easeInOut",
                    }}
                />
            ))}
        </div>
    );
};

export default FloatingParticles;
